import { Component, Input } from '@angular/core';
import { Company } from 'src/app/models/data/company';
import { SubNavComponent } from '../../../../components/sub-nav/sub-nav.component';
import { SubNavTabDirective } from '../../../../components/sub-nav/sub-nav-tab.directive';
import { BreadcrumbLabelDirective } from '../../../../directives/breadcrumb-label.directive';
import { UserDirectoryComponent } from '../../../user/user-directory/user-directory.component';
import { UserWhitelistComponent } from '../../../user/user-whitelist/user-whitelist.component';
import { WhitelistScreens } from '../../../user/user-main-tab/user-main-tab.component';

@Component({
	selector: 'app-company-users',
	imports: [
		SubNavComponent,
		SubNavTabDirective,
		BreadcrumbLabelDirective,
		UserWhitelistComponent,
		UserDirectoryComponent,
	],
	templateUrl: './company-users.component.html',
})
export class CompanyUsersComponent {
	@Input() companyId?: string;
	@Input() company?: Company;
	@Input() canSeeWhitelistTab = false;
	/** When false, hide Accept/Decline/Add Note/Deactivate (Support/Billing view-only). */
	@Input() allowWhitelistMutate = true;
	@Input() breadcrumbLabel = '';

	/** Whitelist Users vs devices view; resets whenever the Users tab content is recreated. */
	canSeeWhitelistUsers = false;

	onWhitelistPageSelectionChanged(selection: WhitelistScreens): void {
		this.canSeeWhitelistUsers = selection === WhitelistScreens.whitelistUsers;
	}
}
